import * as React from 'react';
import { observer } from 'mobx-react-lite';

const styles = require('./FolderPermissionsListItem.scss');
const classNames = require('classnames');

// FolderPermissionsListItem component's props interface
export interface FolderPermissionsListItemProps {
    name: string;
    permissionLevel: string;
    className?: string;
    onClick?: (permissionIndex: number) => void;
    permissionIndex?: number;
}

/**
 * This component renders an item in the FolderPermissionsList component.
 * @prop className: The external class passed to this component. This is an optional prop.
 * @prop name: The name of person/user/group.
 * @prop onCLick: A function to be called on clicking this item. This is an optional prop.
 * @prop permissionLevel: A localised string for permission level.
 */
export default observer(function FolderPermissionsListItem(props: FolderPermissionsListItemProps) {
    const onPermissionIndexClick = React.useCallback(() => {
        props.onClick(props.permissionIndex);
    }, [props.permissionIndex]);

    return (
        <div
            className={classNames(styles.folderPermissionsListItem, props.className)}
            onClick={onPermissionIndexClick}>
            <div className={styles.folderPermissionsNameColumn}>{props.name}</div>
            <div>{props.permissionLevel}</div>
        </div>
    );
});
